import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArtworkCard } from "@/components/site/ArtworkCard";
import { WaitlistForm } from "@/components/site/WaitlistForm";

const FILTERS = [
  { key: "all", label: "All works", cat: null },
  { key: "originals", label: "Original paintings", cat: "Original" },
  { key: "canvas", label: "Canvas prints", cat: "Canvas Print" },
  { key: "posters", label: "Fine art posters", cat: "Fine Art Poster" },
];

export default function Gallery() {
  const [params, setParams] = useSearchParams();
  const active = FILTERS.find((f) => f.key === params.get("filter")) || FILTERS[0];
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api.get("/products", { params: active.cat ? { category: active.cat } : {} }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [active.cat]);

  return (
    <div className="container-x py-16 sm:py-24" data-testid="gallery-page">
      <p className="eyebrow">The collection</p>
      <h1 className="mt-6 font-display text-5xl font-light sm:text-6xl">{active.key === "all" ? "Works" : active.label}</h1>
      <div className="mt-12 flex flex-wrap gap-3 border-b border-[#E5E0D8] pb-10">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            data-testid={`gallery-filter-${f.key}`}
            onClick={() => setParams(f.key === "all" ? {} : { filter: f.key })}
            className={`pill ${f.key === active.key ? "border-[#1A1A1A] bg-[#1A1A1A] text-[#FDFBF7]" : "border-[#D9D3C7] text-[#5A626A] hover:border-[#1A1A1A] hover:text-[#1A1A1A]"}`}
          >
            {f.label}
          </button>
        ))}
      </div>
      {items === null ? (
        <div className="mt-16 grid gap-x-12 gap-y-20 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2].map((i) => <div key={i} className="aspect-[4/5] animate-pulse bg-[#F2EEE6]" />)}
        </div>
      ) : items.length === 0 ? (
        <p className="mt-16 text-sm text-[#5A626A]" data-testid="gallery-empty">No works in this collection yet.</p>
      ) : (
        <div className="mt-16 grid gap-x-12 gap-y-20 sm:grid-cols-2 lg:grid-cols-3" data-testid="gallery-grid">
          {items.map((p, i) => <ArtworkCard key={p.id} p={p} index={i} />)}
        </div>
      )}
      <div className="mt-24 max-w-2xl">
        <WaitlistForm title="Collector waitlist" text="Missed a painting you loved? Join the waitlist and you'll hear first when new originals are finished, before they're released to everyone." testid="gallery-waitlist" />
      </div>
    </div>
  );
}
